<div class="container-fluid">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-7">
            <br>
            <h3>Auri Graduaciones - Registro</h3>
        </div>
        <div class="col-lg-4 col-md-3">
            <br>
            <!-- <a href="inicio">
                <p class="center">Si ya te registraste da click en el siguiente botón</p><br>
                <button class="btn btn-danger">Iniciar Sesión</button>
            </a> -->
        </div>
    </div>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-2 col-md-3">
                    <img src="assets/img/auri.png" width="100%">
                </div>
                <div class="col-lg-8 col-md-6">
                    <br>
                    <p><span class="amarillo2 bold">Grupo:</span> {{grupo.nombre}}<br>
                        <span class="amarillo2 bold">Carrera:</span> {{grupo.carrera}}<br>
                        <span class="amarillo2 bold">Escuela:</span> {{grupo.escuela}}<br>
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Nombre:</span><br>
                    <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario2.nombre"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Apellido Paterno:</span><br>
                    <input type="text" class="form-control" placeholder="Apellido Paterno" [(ngModel)]="formulario2.apellidos"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Apellido Materno:</span><br>
                    <input type="text" class="form-control" placeholder="Apellido Materno" [(ngModel)]="formulario2.apellido_materno"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Celular:</span><br>            
                    <input type="number" class="form-control" placeholder="Celular" [(ngModel)]="formulario2.celular" required><br>
                </div>
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Correo electrónico:</span><br>
                    <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario2.email"><br>
                </div>
                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Contraseña:</span><br>
                     <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="formulario2.password"><br>
                </div>

                <div class="col-lg-4 col-md-4">
                    <span class="amarillo2 bold">Confirma tu contraseña:</span><br>
                    <input type="password" class="form-control" placeholder="Repite tu contraseña" [(ngModel)]="formulario2.password2"><br>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                    <button class="btn btn-warning bold form-control blanco" (click)="validateRegistro();">Siguiente</button>
                </div>
                <div class="col-lg-4"></div>
            </div>
           
            <!-- <button class="btn btn-warning" (click)="agregarUsuarioGrupo(grupoid)">Agregar Usuario</button> -->
            <br><br>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>

<div id="terminosycondiciones" (click)="openModal(mymodal)"></div>
<ng-template #mymodal let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Términos y Condiciones</h4>
                <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

            <div class="modal-body" >
                <div class="alert alert-danger" role="alert">
                    LOS DATOS QUE PROPORCIONAS EN EL FORMULARIO DE REGISTRO SERÁN UTILIZADOS PARA IMPRIMIR TUS PRODUCTOS.
                    <span class="bold">VERIFÍCALOS</span>

                    <p>
                        Nombre: {{formulario2.nombre}}<br>
                        Apellido Paterno: {{formulario2.apellidos}}<br>
                        Apellido Materno: {{formulario2.apellido_materno}}<br>
                        Celular: {{formulario2.celular}}<br>
                        Correo electrónico: {{formulario2.email}}<br>
                    </p>
                </div>
                <div>
                    <iframe src="assets/contratos/contrato_auri.pdf" style="width:100%;height:700px;"></iframe>
                  </div>

            </div>

            <div class="modal-footer">
                <input type="checkbox" [(ngModel)]="isChecked">Acepto los términos y condiciones<br>

     
              <button type="button" class="btn btn-warning" (click)="registrarUsuario(grupoid)">Registrarme</button>
            </div>
            
        </div>

    </div> 
</ng-template>